export function isObject(obj) {
  return obj === Object(obj);
}
